import React from 'react';
import './Error.css';

const Error404 = () => {
    return (

        <div className='Text'>
            <h1>Error 404</h1>
            <p>Page not found Or Being contructed</p>
        </div>

    );
};

export default Error404;